import ko from "knockout";
import _ from "lodash";
import ObservableModel from "util/ObservableModel";

export default ObservableModel.extend({}, function () {
    const self = this;

    self.divisionIds = ko.computed(function () {
        if (self.divisions && self.divisions()) {
            return _.map(self.divisions(), "division.id");
        } else {
            return undefined;
        }
    });
});
